import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { Button, ButtonBar } from '../../../../../../common/components';
import QuoteTab from './components/QuoteTab/QuoteTab';
import ReviewTab from './components/ReviewTab/ReviewTab';
import PaymentTab from './components/PaymentTab/PaymentTab';
import { QUOTES_TAB, REVIEW_TAB, PAY_TAB } from '../../tabs';
import cx from 'classnames';
import './QuoteTabsContainer.scss';

const Title = ({ title, number, isActive }) => (
  <div className="number-tabs">
    <span className={cx({ 'active-tab': isActive })}>
      <span
        className={cx('number', {
          'number-seen': isActive,
          'number-not-seen': !isActive,
        })}
      >
        {number}
      </span>
      <span>{title}</span>
    </span>
  </div>
);
const QuoteTabsContainer = ({
  activeTab,
  allErrors,
  calculatedPremiums,
  channelType,
  definitions,
  finalPremium,
  numTravellers,
  paymentDeclarations,
  paymentType,
  productCode,
  productRules,
  purchaseDeclaration,
  salesChannel,
  selectedSchemes,
  startDate,
  isMta,
  isSaving,
  isCalculating,
  isPurchaseDeclarationAgreed,
  isRefund,
  onTabChange,
  onNextTab,
  onPreviousTab,
  onIssuePolicy,
  onRedirectToIssued,
}) => {
  return (
    <Tabs
      unmountOnExit
      id="smart-luggage"
      onSelect={onTabChange}
      activeKey={activeTab}
      className={'sl-quote-tabs-container'}
    >
      <Tab
        eventKey={QUOTES_TAB}
        title={
          <Title
            title={'Quote'}
            number={QUOTES_TAB}
            isActive={activeTab === QUOTES_TAB}
          />
        }
      >
        <QuoteTab
          allErrors={allErrors}
          premiums={calculatedPremiums || []}
          calculatedPremiums={calculatedPremiums}
          selectedSchemes={selectedSchemes}
          definitions={definitions}
          numTravellers={numTravellers}
          startDate={startDate}
          isCalculating={isCalculating}
          productRules={productRules}
          channelType={channelType}
        />

        <ButtonBar>
          <Button
            label="Next"
            bsStyle="primary"
            className="pull-right btn-action"
            handleClick={onNextTab}
            isLoading={isSaving}
          />
        </ButtonBar>
      </Tab>
      <Tab
        eventKey={REVIEW_TAB}
        title={
          <Title
            title={'Your Details'}
            number={REVIEW_TAB}
            isActive={activeTab === REVIEW_TAB}
          />
        }
      >
        <ReviewTab definitions={definitions} allErrors={allErrors} />

        <ButtonBar>
          <Button
            label="Back"
            bsStyle="secondary"
            className="btn-action"
            handleClick={onPreviousTab}
          />
          <Button
            label="Next"
            bsStyle="primary"
            className="pull-right btn-action"
            handleClick={onNextTab}
            isLoading={isSaving}
          />
        </ButtonBar>
      </Tab>
      <Tab
        eventKey={PAY_TAB}
        title={
          <Title title={'Payment'} number={PAY_TAB} isActive={activeTab === PAY_TAB} />
        }
      >
        <PaymentTab
          purchaseDeclaration={purchaseDeclaration}
          paymentDeclarations={paymentDeclarations}
          finalPremium={finalPremium}
          salesChannel={salesChannel}
          isMta={isMta}
          isPurchaseDeclarationAgreed={isPurchaseDeclarationAgreed}
          isRefund={isRefund}
          paymentType={paymentType}
          productCode={productCode}
          onRedirectToIssued={onRedirectToIssued}
        />
        <ButtonBar>
          <Button
            label="Back"
            bsStyle="secondary"
            className="pull-left"
            handleClick={onPreviousTab}
          />
          <Button
            label="Issue"
            bsStyle="primary"
            isLoading={isSaving}
            className={'pull-right'}
            handleClick={onIssuePolicy}
          />
        </ButtonBar>
      </Tab>
    </Tabs>
  );
};

export default QuoteTabsContainer;
